export const isDev = false;

export const API = {
  URL: isDev
    ? "http://master.api.is74.ru"
    : "https://api.is74.ru",
  ML_URL: "https://stories-ml.is74.ru",
  PAYMENT_URL: isDev
    ? "http://10.80.0.104:8093"
    : "https://payment.is74.ru",
  TRACK_URL: "https://track.is74.ru",
  TOKEN: $_GET("token"),
};

export const DEMO_USER_ID = 3989116;

export const SUBSCRIPTION_TYPE_ID = 121;

// API
export const GET_SUBSCRIPTION = () => `${API.URL}/mobile/subscriptions/${SUBSCRIPTION_TYPE_ID}/description`;
export const GET_SERVICES = () => `${API.URL}/mobile/smartyard/services/subscriptions`;
export const GET_USER_ID = () => `${API.URL}/token/info`;
export const SEND_SELECTED_SERVICES = () => `${API.URL}/mobile/smartyard/services/order-save`;
export const GET_ABONENT_INFO = () => `${API.URL}/mobile/smartyard/access`;
export const START_SUBSCRIPTION = () => `${API.URL}/mobile/subscriptions/${SUBSCRIPTION_TYPE_ID}/start`;

//экран управления подпиской
export const GET_CLIENT_CARD = () => `${API.PAYMENT_URL}/api/card/info`;
export const GET_BALANCE = () => `${API.URL}/user/balance`;
export const GET_SUBSCRIPTION_INFO = () => `${API.URL}/mobile/subscriptions/${SUBSCRIPTION_TYPE_ID}/info`;
export const GET_UNSUBSCRIBE_REASONS = () => `${API.URL}/smartYard/subscription/reasons-unsubscribe`;
export const RESUME_SUBSCRIPTION = () => `${API.URL}/mobile/subscriptions/${SUBSCRIPTION_TYPE_ID}/resume`;
export const STOP_AND_UNSUBSCRIBE = () => `${API.URL}/mobile/subscriptions/stopAndUnsubscribe`;

//экран статеров+
export const GET_ALL_SERVICES = () => `${API.URL}/user/service`;

//API ML-STORIES
export const GET_NEW_STORIES = () => `${API.URL}/mobile/smartyard/services`;

//LOGGING
export const POST_USER_EVENT = () => `${API.TRACK_URL}/mobile/track`;

// Экран карты камер
export const GET_CAMERA_LIST = () => `https://cams.is74.ru/api/self-cams-with-group`;
export const GET_INTERCOM_VIDEO = (id) => `https://cams.is74.ru${id}`;
export const GET_USER_LOCATION = () => `${API.URL}/user/address?expand=geo`;

//Получаем токен из МП
function $_GET(key) {
 let par = window.location.search;
 par = par.match(new RegExp(key + "=([^&=]+)"));
 return par ? par[1] : false;
}

export function dateFormat(date) {
  return new Date(date).toLocaleString().slice(0, 10);
}

export function getSawPayModalCookie() {
  let par = document.cookie;
  par = par.match(new RegExp("saw_pay_modal" + "=([^&=]+)"));

  return par ? par[1].split(";")[0] : false;
}

export function getPayMethodCookie() {
  let par = document.cookie;
  par = par.match(new RegExp("pay_method" + "=([^&=]+)"));

  return par ? par[1].split(";")[0] : false;
}
